import { FgBlockType } from '../../block-type.js';
import { fgVectorSlerp } from '../../fg-math.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { FgType } from '../../types.js';

const vectorSlerpDef = {
  type: FgBlockType.VectorSlerp,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any), sockIn("b", FgType.Any), sockIn("c", FgType.Number)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", fgVectorSlerp(getDataValue(ctx, env, block, "a"), getDataValue(ctx, env, block, "b"), getDataValue(ctx, env, block, "c")));
  }
};

export { vectorSlerpDef };
//# sourceMappingURL=vector-slerp.js.map
